import axios from 'axios'

export const getAllAwards = () => {
  return axios.get('/award')
}

export const getAward = ({ id }) => {
  return axios.get(`/award/${id}`)
}

export const getMyAwards = () => {
  return axios.get(`/award/my-awards`)
}
